
import React from 'react';

const PrivacyPolicyPage: React.FC = () => {
    return (
        <div className="pt-20 bg-white"> {/* Header offset */}
            <header className="bg-gray-800 text-white py-12 md:py-16">
                <div className="container mx-auto px-6 text-center">
                    <h1 className="text-3xl md:text-4xl font-extrabold uppercase tracking-widest">Privacy Policy</h1>
                </div>
            </header>

            <div className="bg-gray-50">
                <div className="container mx-auto px-6 py-16">
                    <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-lg shadow-lg border border-gray-200">
                        <article className="prose lg:prose-lg max-w-none text-gray-700" style={{'--tw-prose-bullets': '#3aabd2', '--tw-prose-links': '#3aabd2'} as React.CSSProperties}>
                            <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-[#3aabd2] pb-2 mb-6">個人情報の取り扱いについて</h2>
                            <p>株式会社AgLab（以下、「当社」とする。）では、利用者の個人情報がプライバシーを構成する重要な情報であることを深く認識し、個人情報の保護に関する法律、個人情報保護に関するガイドライン等の指針、その他個人情報保護に関する関係法令を遵守します。</p>

                            <h3 className="text-xl font-semibold text-gray-800 mt-8 mb-4">本サイト閲覧について</h3>
                            <p>通常、利用者のいかなる情報も提供していただくことなく、閲覧していただけます。ただし、本サイト内における利用者からのお問い合わせへの対応、サービスを提供するために必要な氏名、メールアドレス、住所、電話番号などの個人情報の提供をお願いする場合があります。この場合、利用者の個人情報は、データの蓄積および情報提供の目的以外には一切使用いたしません。また、利用者の個人情報を利用者の許可なく第三者と共有することはありません。</p>

                            <h3 className="text-xl font-semibold text-gray-800 mt-8 mb-4">通信記録（アクセスログ）について</h3>
                            <p>本サイトのサーバ上に記録されたアクセスログについては、利用動向の調査（例えば、アクセス数の集計）などのより良い運営のために使用することはありますが、これにより個人を特定することはいたしません。ただし、悪質ないたずらや犯罪などで裁判所や警察などの公的機関から法令に基づいた情報提供を求められた場合は、この限りではありません。</p>
                            
                            <h3 className="text-xl font-semibold text-gray-800 mt-8 mb-4">リンク先（第三者のサイト）について</h3>
                            <p>本サイトを通じてアクセスできる第三者のサイト（リンク先）は、本サイトとは別に、独自のプライバシー保護や個人情報の収集に関する規定を定めています。本サイトはこれら第三者のサイトが行う個人情報の取り扱いに対しては、いかなる義務や責任も負いかねます。</p>

                            <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-[#3aabd2] pb-2 mb-6 mt-12">開示、訂正、利用停止、削除依頼等の求めに応じる手続き</h2>
                            <p>当社が保有する個人情報のご請求については、合理的な範囲で速やかに対応いたします。<br />※ただし、ご請求内容によっては開示等に応じられない場合がございます。その場合はその理由に関しても回答いたします。</p>
                            <p>担当者：株式会社AgLab<br />mail：info@aglab.co.jp</p>

                            <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-[#3aabd2] pb-2 mb-6 mt-12">組織・体制</h2>
                            <p>当社は、個人情報を保護するために適切な管理体制を整えるとともに、役員及び職員に対し個人情報保護に関する意識啓発に努めます。<br />なお、ユーザー様から取得した個人情報につきましては、当社において個人情報の取扱いを許可された者以外が容易に閲覧することができない形で保管する等の措置を講ずることで、厳重に安全管理されるよう努めております。</p>
                            
                            <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-[#3aabd2] pb-2 mb-6 mt-12">著作権について</h2>
                            <p>本サイト内の掲載物の著作権は株式会社AgLabまたは関係者が保有します。本サイト内の掲載物を無断で複製、転載等の利用をすることを禁止します。</p>
                            
                            <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-[#3aabd2] pb-2 mb-6 mt-12">免責事項</h2>
                            <p>本サイト内の掲載情報については、細心の注意を払っておりますが、その内容の正確性を保証するものではありません。本サイト内の掲載内容は予告なく変更または削除する場合があります。利用者が本サイト内の掲載情報によって被った損害・損失に対して一切の責任を負いません。</p>
                            
                            <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-[#3aabd2] pb-2 mb-6 mt-12">リンクについて</h2>
                            <p>本サイトへのリンクを掲載する際には、そのWEBサイトの内容とURL、リンク掲載の主旨をご連絡ください。なお、本サイトの主旨にそぐわない目的でのリンクについてはお断りすることがあります。</p>

                            <div className="mt-12 pt-6 border-t border-gray-200 text-right text-sm text-gray-600">
                                <p>第⼀版 2025年2月7日</p>
                                <p>代表取締役 相川 直輝</p>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;
